import React from 'react'
import TestNav from '../components/TestNav'

function Test() {
  return (
   <TestNav />
  )
}

export default Test